export const googleClientId = "512207636442-hp1vtt2ec05tijpfpfpil7vscg1h3ids.apps.googleusercontent.com"

